module.exports = function (e) {
  var t = {};

  function r(n) {
    if (t[n]) return t[n].exports;
    var o = t[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
  }

  return r.m = e, r.c = t, r.d = function (e, t, n) {
    r.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r.t = function (e, t) {
    if (1 & t && (e = r(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (r.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      r.d(n, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return n;
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return r.d(t, "a", t), t;
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.p = "", r(r.s = 5);
}([function (e, t, r) {
  e.exports = r(3)();
}, function (e, t) {
  e.exports = require("react");
}, function (e, t, r) {
  e.exports = function (e) {
    var t = {};

    function r(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        r.d(n, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 1);
  }([function (e, t) {
    e.exports = r(1);
  }, function (e, t, r) {
    "use strict";

    r.r(t), r.d(t, "useElapsedTime", function () {
      return a;
    });
    var n = r(0);

    function o(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
          var r = [],
              n = !0,
              o = !1,
              i = void 0;

          try {
            for (var a, u = e[Symbol.iterator](); !(n = (a = u.next()).done) && (r.push(a.value), !t || r.length !== t); n = !0) {
              ;
            }
          } catch (e) {
            o = !0, i = e;
          } finally {
            try {
              n || null == u.return || u.return();
            } finally {
              if (o) throw i;
            }
          }

          return r;
        }
      }(e, t) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return i(e, t);
          var r = Object.prototype.toString.call(e).slice(8, -1);
          return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(r) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? i(e, t) : void 0;
        }
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function i(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var r = 0, n = new Array(t); r < t; r++) {
        n[r] = e[r];
      }

      return n;
    }

    var a = function a(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = t.duration,
          i = t.onComplete,
          a = t.startAt,
          c = void 0 === a ? 0 : a,
          l = t.autoResetKey,
          f = Object(n.useState)(c),
          s = o(f, 2),
          p = s[0],
          d = s[1],
          y = Object(n.useRef)(-1e3 * c),
          m = Object(n.useRef)(null),
          b = Object(n.useRef)(null),
          v = Object(n.useRef)(null),
          g = Object(n.useRef)(!1),
          h = Object(n.useRef)(!1),
          O = Object(n.useRef)(0),
          j = Object(n.useCallback)(function (e) {
        O.current += 1, d("number" == typeof e ? e : c);
      }, []),
          w = function e(t) {
        var n = t / 1e3;
        if (null === b.current) return b.current = n, void (m.current = requestAnimationFrame(e));
        var o = n - b.current;

        if (b.current = n, d(function (e) {
          var t = e + o;
          return "number" != typeof r || t < r ? t : (h.current = !0, r);
        }), h.current) {
          if ("function" == typeof i) {
            y.current += 1e3 * r;
            var a = y.current / 1e3,
                u = i(a) || {},
                c = u.shouldRepeat,
                l = void 0 !== c && c,
                f = u.delay,
                s = void 0 === f ? 0 : f,
                p = u.newStartAt;
            l && g.current && (v.current = setTimeout(function () {
              j(p);
            }, 1e3 * s));
          }
        } else m.current = requestAnimationFrame(e);
      },
          S = function S() {
        cancelAnimationFrame(m.current), clearTimeout(v.current), b.current = null;
      };

      return u(function () {
        return e && (m.current = requestAnimationFrame(w)), S;
      }, [e]), u(function () {
        e && g.current && (S(), m.current = requestAnimationFrame(w));
      }, [r]), u(function () {
        g.current && j();
      }, [l]), u(function () {
        e && h.current && (S(), m.current = requestAnimationFrame(w)), h.current = !1;
      }, [O.current]), u(function () {
        return g.current = !0, function () {
          g.current = !1;
        };
      }, []), {
        elapsedTime: p,
        reset: j
      };
    },
        u = "undefined" == typeof window ? n.useEffect : n.useLayoutEffect;
  }]);
}, function (e, t, r) {
  "use strict";

  var n = r(4);

  function o() {}

  function i() {}

  i.resetWarningCache = o, e.exports = function () {
    function e(e, t, r, o, i, a) {
      if (a !== n) {
        var u = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw u.name = "Invariant Violation", u;
      }
    }

    function t() {
      return e;
    }

    e.isRequired = e;
    var r = {
      array: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: t,
      element: e,
      elementType: e,
      instanceOf: t,
      node: e,
      objectOf: t,
      oneOf: t,
      oneOfType: t,
      shape: t,
      exact: t,
      checkPropTypes: i,
      resetWarningCache: o
    };
    return r.PropTypes = r, r;
  };
}, function (e, t, r) {
  "use strict";

  e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}, function (e, t, r) {
  "use strict";

  r.r(t), r.d(t, "CountdownCircleTimer", function () {
    return D;
  });

  var n = r(1),
      o = r.n(n),
      i = function i(e) {
    return {
      position: "relative",
      width: e,
      height: e
    };
  },
      a = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    left: 0,
    top: 0,
    width: "100%",
    height: "100%"
  },
      u = function u(e) {
    return e.match(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/);
  },
      c = function c(e, t) {
    return "Invalid prop '".concat(e, "' supplied to '").concat(t, "'");
  },
      l = function l(e, t) {
    var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "array";
    return new Error("".concat(c(e, t), ". Expect ").concat("array" === r ? "an array of tuples where the first element is a" : "", " HEX color code string.\n ."));
  },
      f = function f(e) {
    return "countdown-circle-timer-gradient-".concat(e || Math.random().toString(36).substring(2));
  },
      s = function s(e, t) {
    return 0 === t ? 0 : "number" == typeof e ? t - e : 0;
  },
      p = r(0),
      d = r.n(p),
      y = {
    duration: d.a.number.isRequired,
    colors: function colors(e, t, r) {
      var n = e[t];
      return "string" == typeof n ? function (e, t, r) {
        if (!u(e)) return l(t, r, "string");
      }(n, t, r) : function (e, t, r) {
        for (var n = 0; n < e.length; n += 1) {
          var o = e[n][0],
              i = e[n][1];
          if (!u(o)) return l(t, r);
          if (!(void 0 === i || i >= 0 && i <= 1)) return new Error("".concat(c(t, r), ".\n        Expect an array of tuples where the second element is a number between 0 and 1 representing color transition duration."));
        }
      }(n, t, r);
    },
    children: d.a.oneOfType([d.a.func, d.a.node]),
    size: d.a.number,
    strokeWidth: d.a.number,
    trailColor: d.a.string,
    isPlaying: d.a.bool,
    strokeLinecap: d.a.oneOf(["round", "square"]),
    isLinearGradient: d.a.bool,
    gradientUniqueKey: d.a.string,
    onComplete: d.a.func,
    ariaLabel: d.a.string,
    renderAriaTime: d.a.func,
    initialRemainingTime: d.a.number,
    rotation: d.a.oneOf(["clockwise", "counterclockwise"])
  };

  function m() {
    return (m = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];

        for (var n in r) {
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  function b(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var r = [],
          n = !0,
          o = !1,
          i = void 0;

      try {
        for (var a, u = e[Symbol.iterator](); !(n = (a = u.next()).done) && (r.push(a.value), !t || r.length !== t); n = !0) {
          ;
        }
      } catch (e) {
        o = !0, i = e;
      } finally {
        try {
          n || null == u.return || u.return();
        } finally {
          if (o) throw i;
        }
      }

      return r;
    }(e, t) || g(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function v(e) {
    return function (e) {
      if (Array.isArray(e)) return h(e);
    }(e) || function (e) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
    }(e) || g(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function g(e, t) {
    if (e) {
      if ("string" == typeof e) return h(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? h(e, t) : void 0;
    }
  }

  function h(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var r = 0, n = new Array(t); r < t; r++) {
      n[r] = e[r];
    }

    return n;
  }

  var O = function O(e) {
    var t = e.gradientId,
        r = e.colors,
        n = e.defs,
        i = void 0 === n ? "defs" : n,
        a = e.linearGradient,
        u = void 0 === a ? "linearGradient" : a,
        c = e.stop,
        l = void 0 === c ? "stop" : c;
    return o.a.createElement(i, null, o.a.createElement(u, {
      id: t,
      x1: "1",
      y1: "0",
      x2: "0",
      y2: "0"
    }, function (e) {
      var t = "string" == typeof e;
      if (t || 1 === e.length) return [{
        offset: 1,
        stopColor: t ? e : e[0][0],
        key: 0
      }];
      var r = e.length,
          n = 0;
      return [{
        offset: 0,
        stopColor: e[0][0],
        key: 0
      }].concat(v(e.map(function (e, t) {
        var o = b(e, 2),
            i = o[0],
            a = o[1];
        return n += a, {
          offset: r === t + 1 ? 1 : n,
          stopColor: i,
          key: t + 1
        };
      })));
    }(r).map(function (e) {
      return o.a.createElement(l, m({}, e, {
        key: e.key
      }));
    })));
  },
      j = d.a.oneOfType([d.a.func, d.a.string]);

  O.propTypes = {
    gradientId: d.a.string.isRequired,
    colors: y.colors,
    defs: j,
    linearGradient: j,
    stop: j
  };

  var w = r(2),
      S = function S(e, t, r, n) {
    return 0 === n ? r : t + r * (e / n);
  };

  function P(e, t) {
    var r = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }

    return r;
  }

  function T(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? P(Object(r), !0).forEach(function (t) {
        A(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : P(Object(r)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }

    return e;
  }

  function A(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = r, e;
  }

  var E = function E(e) {
    var t = e.r,
        r = e.g,
        n = e.b,
        o = e.opacity;
    return "rgba(".concat(t, ", ").concat(r, ", ").concat(n, ", ").concat(o, ")");
  },
      k = function k(e, t) {
    var r = function (e) {
      return e.map(function (e) {
        var t = e[0].replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function (e, t, r, n) {
          return "#".concat(t).concat(t).concat(r).concat(r).concat(n).concat(n);
        }).substring(1).match(/.{2}/g).map(function (e) {
          return parseInt(e, 16);
        });
        return [{
          r: t[0],
          g: t[1],
          b: t[2],
          opacity: 1
        }, e[1]];
      });
    }(e);

    if (!t) return r;
    var n = 0;
    return r.map(function (e, t) {
      var o = r.length === t + 1,
          i = "0%";

      if (t > 0) {
        var a = r[t - 1][1],
            u = Math.round(100 * a);
        (n += u) > 100 || o ? (n = 100, i = "100%") : i = "".concat(n, "%");
      }

      var c = {
        offset: i,
        stopColor: E(e[0]),
        key: t
      };
      return [T(T({}, e[0]), {}, {
        gradient: c
      }), e[1]];
    });
  },
      x = function x(e, t) {
    if (1 === e.length) return E(e[0]);
    var r = e.find(function (e) {
      var r = e.colorEndTime;
      return t <= r;
    });
    if (void 0 === r.duration) return E(r);
    var n = t - r.colorStartTime,
        o = 0 | S(n, r.r, r.goalR, r.duration),
        i = 0 | S(n, r.g, r.goalG, r.duration),
        a = 0 | S(n, r.b, r.goalB, r.duration);
    return E({
      r: o,
      g: i,
      b: a,
      opacity: r.opacity
    });
  },
      C = {
    position: "absolute",
    width: "1px",
    height: "1px",
    margin: "-1px",
    border: 0,
    clip: "rect(0 0 0 0)",
    padding: 0,
    overflow: "hidden",
    whiteSpace: "nowrap",
    wordWrap: "normal"
  };

  function I(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var r = [],
          n = !0,
          o = !1,
          i = void 0;

      try {
        for (var a, u = e[Symbol.iterator](); !(n = (a = u.next()).done) && (r.push(a.value), !t || r.length !== t); n = !0) {
          ;
        }
      } catch (e) {
        o = !0, i = e;
      } finally {
        try {
          n || null == u.return || u.return();
        } finally {
          if (o) throw i;
        }
      }

      return r;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return R(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === r && e.constructor && (r = e.constructor.name);
      if ("Map" === r || "Set" === r) return Array.from(e);
      if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return R(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function R(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var r = 0, n = new Array(t); r < t; r++) {
      n[r] = e[r];
    }

    return n;
  }

  var _ = function _(e) {
    var t = e.isPlaying,
        r = e.size,
        o = e.strokeWidth,
        u = e.duration,
        c = e.initialRemainingTime,
        l = e.colors,
        p = e.isLinearGradient,
        d = e.gradientUniqueKey,
        y = e.onComplete,
        m = e.rotation,
        b = Object(n.useRef)({
      duration: u,
      startAt: s(c, u)
    }).current,
        v = b.duration,
        g = b.startAt,
        h = Object(n.useMemo)(function () {
      return function (e, t, r) {
        var n = e / 2,
            o = t / 2,
            i = n - o,
            a = 2 * i,
            u = "clockwise" === r ? "1,0" : "0,1",
            c = 2 * Math.PI * i;
        return {
          path: "m ".concat(n, ",").concat(o, "\n          a ").concat(i, ",").concat(i, " 0 ").concat(u, " 0,").concat(a, "\n          a ").concat(i, ",").concat(i, " 0 ").concat(u, " 0,-").concat(a),
          pathLength: c
        };
      }(r, o, m);
    }, [r, o, m]),
        O = h.path,
        j = h.pathLength,
        P = Object(n.useMemo)(function () {
      return function (e, t, r) {
        var n = k("string" == typeof e ? [[e, 1]] : e, r),
            o = 0;
        return n.map(function (e, r) {
          var i = n.length === r + 1;
          if (o >= t || i) return o = t, T(T({}, e[0]), {}, {
            colorEndTime: o
          });
          var a = o,
              u = void 0 !== e[1] ? a + e[1] * t : t,
              c = u >= t ? t : u,
              l = n[r + 1][0],
              f = {
            goalR: l.r - e[0].r,
            goalG: l.g - e[0].g,
            goalB: l.b - e[0].b
          };
          return o = c, T(T(T({}, e[0]), f), {}, {
            colorStartTime: a,
            colorEndTime: c,
            duration: c - a
          });
        });
      }(l, v, p);
    }, [l, v, p]),
        A = Object(n.useMemo)(function () {
      return f(d);
    }, [d]),
        E = Object(w.useElapsedTime)(t, {
      duration: v,
      startAt: g,
      onComplete: "function" == typeof y ? function () {
        var e = y.apply(void 0, arguments) || [],
            t = I(e, 2),
            r = t[0],
            n = void 0 !== r && r,
            o = t[1],
            i = void 0 === o ? 0 : o;
        return {
          shouldRepeat: n,
          delay: i / 1e3,
          newStartAt: 0
        };
      } : void 0
    }).elapsedTime;
    return {
      path: O,
      pathLength: j,
      gradientId: A,
      stroke: x(P, E),
      strokeDashoffset: S(E, 0, j, v),
      timeProps: {
        remainingTime: Math.ceil(v - E),
        elapsedTime: E
      },
      styles: {
        wrapperStyle: i(r),
        timeStyle: a,
        visuallyHidden: C
      }
    };
  };

  function L(e, t) {
    var r = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }

    return r;
  }

  function M(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? L(Object(r), !0).forEach(function (t) {
        q(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : L(Object(r)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }

    return e;
  }

  function q(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = r, e;
  }

  var D = function D(e) {
    var t = e.size,
        r = e.strokeWidth,
        n = e.trailColor,
        i = e.duration,
        a = e.isPlaying,
        u = e.colors,
        c = e.strokeLinecap,
        l = e.children,
        f = e.isLinearGradient,
        s = e.gradientUniqueKey,
        p = e.onComplete,
        d = e.ariaLabel,
        y = e.renderAriaTime,
        m = e.initialRemainingTime,
        b = e.rotation,
        v = _({
      isPlaying: a,
      size: t,
      strokeWidth: r,
      duration: i,
      initialRemainingTime: m,
      colors: u,
      isLinearGradient: f,
      gradientUniqueKey: s,
      onComplete: p,
      rotation: b
    }),
        g = v.path,
        h = v.pathLength,
        j = v.stroke,
        w = v.strokeDashoffset,
        S = v.gradientId,
        P = v.styles,
        T = v.timeProps;

    return o.a.createElement("div", {
      style: P.wrapperStyle,
      "aria-label": d
    }, o.a.createElement("svg", {
      width: t,
      height: t,
      xmlns: "http://www.w3.org/2000/svg"
    }, f && o.a.createElement(O, {
      colors: u,
      gradientId: S
    }), o.a.createElement("path", {
      d: g,
      fill: "none",
      stroke: n,
      strokeWidth: r
    }), o.a.createElement("path", {
      d: g,
      fill: "none",
      stroke: f ? "url(#".concat(S, ")") : j,
      strokeLinecap: c,
      strokeWidth: r,
      strokeDasharray: h,
      strokeDashoffset: w
    })), null !== l && o.a.createElement("div", {
      "aria-hidden": "true",
      style: M(M({}, P.timeStyle), {}, {
        color: j
      })
    }, o.a.isValidElement(l) ? o.a.cloneElement(o.a.Children.only(l), T) : l(T)), "function" == typeof y && o.a.createElement("div", {
      role: "timer",
      "aria-live": "assertive",
      style: P.visuallyHidden
    }, y(T)));
  };

  D.propTypes = y, D.defaultProps = {
    size: 180,
    strokeWidth: 12,
    trailColor: "#d9d9d9",
    isPlaying: !1,
    strokeLinecap: "round",
    isLinearGradient: !1,
    ariaLabel: "Countdown timer",
    children: null,
    rotation: "clockwise"
  }, D.displayName = "CountdownCircleTimer";
}]);